import React, {useContext, useEffect, Suspense, lazy} from 'react'
import { Routes, Route} from 'react-router-dom'

import FrontendLayout from "./FrontendLayout"
import ScrollToTop from '../components/ScrollToTop/ScrollToTop'
import RootContext from '../context/RootContext'
import Loader from "../Loader/Loader"


import Home from '../views/Home'
import About from '../views/About'
import Projects from '../views/Projects'
import Education from '../views/Education'
import Experience from '../views/Experience'
import Contact from '../views/Contact'
import Publication from '../views/Publication'
import Skills from '../views/Skils'

const Error404 = lazy( () => import('../errors/Error404'))

const AppRoutes = () => {

  const {loading, setLoading } =  useContext(RootContext)

  useEffect( () => {
    setLoading(false);
  },[setLoading])

  return loading ? < Loader/> : (
    <Suspense fallback={<Loader />}>
      <ScrollToTop>
        <Routes>
          <Route path="/*" element={<FrontendLayout />}>
              <Route index element={<Home />}/>
              <Route path="about" element={<About />}/>
              <Route path="education" element={<Education />}/>
              <Route path="experience" element={<Experience />}/>
              <Route path="skills" element={<Skills />}/>
              <Route path="publication" element={<Publication />}/>
              <Route path="projects" element={<Projects />}/>
              <Route path="contact" element={<Contact />}/>
              <Route path="*" element={<Error404 />} />
          </Route>
        </Routes>
    </ScrollToTop>
  </Suspense>
  )
}

export default AppRoutes